(() => {
  // GORIT-75: Remove the tabindex="0" attribute and value from the containers.
  const selector = '[data-rebuy-component="announcement-bar"]';
  const removedTabIndexes = new WeakMap();

  // Rebuy's own template supports multiple messages
  const hasSingleSlide = (element) => {
    const slider = element.querySelector('.flickity-slider');
    return !!slider && slider.children.length <= 1;
  };

  const updateTabIndex = (element) => {
    if (element.matches(selector) && hasSingleSlide(element)) {
      if (element.hasAttribute('tabindex')) {
        removedTabIndexes.set(element, element.getAttribute('tabindex'));
        element.removeAttribute('tabindex');
      }
    } else if (removedTabIndexes.has(element)) {
      // Restore only attributes we removed; preserve any newer Rebuy value.
      if (!element.hasAttribute('tabindex')) {
        element.setAttribute('tabindex', removedTabIndexes.get(element));
      }
      removedTabIndexes.delete(element);
    }
  };

  const scan = (root) => {
    if (root.nodeType !== 1) return;
    updateTabIndex(root);
    root.querySelectorAll(selector).forEach(updateTabIndex);
  };

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        updateTabIndex(mutation.target);
      } else {
        const announcement = mutation.target.closest(selector);
        if (announcement) updateTabIndex(announcement);
        mutation.addedNodes.forEach(scan);
      }
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['tabindex', 'data-rebuy-component'],
  });

  scan(document.body);
})();
